import {
    SHOW_SIDEBAR_MENU,
    HIDE_SIDEBAR_MENU,
    SET_USER,
    SET_USER_COPY,
    SET_ELECTRON_APP
} from '../constants/actions';

export const showSidebarMenu = () => ({
    type: SHOW_SIDEBAR_MENU
});

export const hideSidebarMenu = () => ({
    type: HIDE_SIDEBAR_MENU
});

export const setUser = (user) => ({
    type: SET_USER,
    user: user
});

export const setUserCopy = (userCopy) => ({
    type: SET_USER_COPY,
    userCopy: userCopy
});

export const setElectronApp = (electronApp) => ({
    type: SET_ELECTRON_APP,
    electronApp: electronApp
})